import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M13.349 12.372a.75.75 0 0 0 1.302-.744L10.75 4.8V3.31l.78-.78A.75.75 0 0 0 11 1.25H7a.75.75 0 0 0-.53 1.28l.78.78v.94H5a.75.75 0 0 0-.53 1.28l.78.78V7.8l-3.901 6.828A.75.75 0 0 0 2 15.75h10a.75.75 0 0 0 .651-1.122L8.75 7.8V6.31l.722-.723 3.877 6.784ZM9.25 4.292V3a.75.75 0 0 1 .043-.25h-.586A.75.75 0 0 1 8.75 3v1.25H9c.087 0 .171.015.25.043Zm-1.901 4.08 3.359 5.878H3.292l3.36-5.878A.75.75 0 0 0 6.75 8V6a.75.75 0 0 0-.043-.25h.586A.75.75 0 0 0 7.25 6v2c0 .13.034.259.099.372Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  n
];
function r(a, d) {
  return e(), l("svg", t, [...c]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
